module.exports = __webpack_public_path__ + "static/media/Garrett-mini.cd26ebdd.jpg";